import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/layout/Header';
import { PromoBanner } from './components/layout/PromoBanner';
import { Footer } from './components/layout/Footer';
import { FloatingActions } from './components/layout/FloatingActions';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { ServiceDetail } from './pages/ServiceDetail';
import { Portfolio } from './pages/Portfolio';
import { Reviews } from './pages/Reviews';
import { FaqPage } from './pages/Faq';
import { Process } from './pages/Process';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
type AppProps = {
  showPromoBanner?: boolean;
  defaultLanguage?: 'en' | 'es';
};
export function App({
  showPromoBanner = true,
  defaultLanguage = 'en'
}: AppProps) {
  return <LanguageProvider defaultLanguage={defaultLanguage} data-id="element-0" data-mp="3ik7fqfdqo9q4">
      <BrowserRouter data-id="element-1" data-mp="3ijpcgysnsv8p">
        <ScrollToTop data-id="element-2" data-mp="3ii4qvyobommz" />
        <div className="flex min-h-screen w-full flex-col bg-white" data-id="element-3" data-mp="3ml14tc2x3ukl">
          {showPromoBanner ? <PromoBanner data-id="element-4" data-mp="3rcj6618urx63" /> : null}
          <Header data-id="element-5" data-mp="3rdas0kcnegj6" />
          <div className="flex-1" data-id="element-6" data-mp="3rcswjpxt86cb">
            <Routes data-id="element-7" data-mp="5yjetptzbev">
              <Route path="/" element={<Home data-id="element-9" data-mp="4n4bxqxqh8g" />} data-id="element-8" data-mp="6hovayao7c0" />
              <Route path="/services" element={<Services data-id="element-11" data-mp="2zld1d7i6tbah" />} data-id="element-10" data-mp="56lhc8rh1lf" />
              <Route path="/services/:slug" element={<ServiceDetail data-id="element-13" data-mp="2zn69yscd25l4" />} data-id="element-12" data-mp="2zm4yimrfnh2v" />
              <Route path="/portfolio" element={<Portfolio data-id="element-15" data-mp="33nges1of2pye" />} data-id="element-14" data-mp="33mf0loc3tncg" />
              <Route path="/reviews" element={<Reviews data-id="element-17" data-mp="38m1elzzrb7mb" />} data-id="element-16" data-mp="33oriy2lrxzq1" />
              <Route path="/faq" element={<FaqPage data-id="element-19" data-mp="38kgkgbhctqoz" />} data-id="element-18" data-mp="38kqb81a841vq" />
              <Route path="/process" element={<Process data-id="element-21" data-mp="3dl4l7ovdxlwe" />} data-id="element-20" data-mp="3dkuufz2inapn" />
              <Route path="/about" element={<About data-id="element-23" data-mp="3dii530ufhy2k" />} data-id="element-22" data-mp="3dmfolnkx4rmz" />
              <Route path="/contact" element={<Contact data-id="element-25" data-mp="nur948fv0n11" />} data-id="element-24" data-mp="nw2a60hx7gog" />
              <Route path="*" element={<Home data-id="element-27" data-mp="sunf2d84aoj8" />} data-id="element-26" data-mp="nxn4bp0boxls" />
            </Routes>
          </div>
          <Footer data-id="element-28" data-mp="sssq8ntq6c9v" />
          <FloatingActions data-id="element-29" data-mp="swgk5o3310p4" />
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}